import {
  Button,
  Input,
  List,
  Modal,
  Popconfirm,
  Select,
  Spin,
  Steps,
  Tag,
  Tooltip,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../config/axios-instance";
import proto_illustration from "../../img/Prototype.svg";
import avatar_placeholder from "../../img/avatar_placeholder.jpg";
import { useState } from "react";
import backArrow from "../../img/backArrow.png";
import { history } from "../..";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import Avatar from "antd/lib/avatar/avatar";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DatabaseOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { backgroundImage } from "html2canvas/dist/types/css/property-descriptors/background-image";
import { CancelOrderDrawer } from "../MyOrderConfirmation/CancelOrderDrawer";
import { MyNotif } from "../NotifIcons/NotifIcons";
import {
  approveOptionAndComment,
  approveProductAndComment,
  rejectOrAcceptProtoDemcoProduct,
} from "../../actions/order-actions/actions";
const { Step } = Steps;
const { Option } = Select;

const NormalOrderProgress = () => {
  const params = useParams<any>();
  const routerHistory = useHistory();

  const [product, setProduct] = useState<any>({ data: null, product: null });
  const [isLoading, setIsLoading] = useState(false);

  const [isOpened, setIsOpened] = useState(false);
  function edit() {
    setIsOpened((wasOpened) => !wasOpened);
  }
  const [comment, setComment] = useState("");

  const [proto, setProto] = useState("");
  const [startDate, setStartDate] = useState("");
  const [shippingDate, setShippingDate] = useState("");
  const [datetirmswearhouse, setTirmswearhouse] = useState("");
  const [datefabricwearhouse, setFabricwearhouse] = useState("");
  const [step, setSetp] = useState(product?.product?.status?.id);
  const [selectdStep, setSelectdStep] = useState("");
  const [qty, setQty] = useState("");
  const [size_qty, setSizeQty] = useState("");
  const [deliverydate, setDeliveryDate] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  function handleChangeProto(e: any) {
    setProto(e.target.value);
  }

  function handleChangeStartDate(e: any) {
    setStartDate(e.target.value);
  }
  function handleChangeShippingDate(e: any) {
    setShippingDate(e.target.value);
  }

  function handleChangeDateTirmswearhouse(e: any) {
    setTirmswearhouse(e.target.value);
  }

  function handleChangeDateFabricwearhouse(e: any) {
    setFabricwearhouse(e.target.value);
  }
  function handleChangeDeliveryDate(e: any) {
    setDeliveryDate(e.target.value);
  }
  const showCancelDrawer = () => {
    setIsVisible(true);
  };
  const {
    mutateAsync: approveOptAndComment,
    isLoading: approvingAndCommentLoading,
  } = useMutation(approveProductAndComment);

  const {
    mutateAsync: rejectOrAcceptProto,
    isLoading: rejectOrAcceptProtoLoading,
  } = useMutation(rejectOrAcceptProtoDemcoProduct, {
    onSuccess: (res) => {
      MyNotif(`Product ${res}ed and comments added successfully`, "success");
      window.location.reload();
    },
  });
  const valider = async (status: any, product_id: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/orders_produts/admin/${params.order_id}`,
      data: {
        status_id: status,
        product_id: product_id,
        proto: proto,
        start_production_date: startDate,
        shipping_date: shippingDate,
        qty: qty,
        size_qty: size_qty,
        delivery_date: deliverydate,
        date_trims_wearhouse: datetirmswearhouse,
        date_fabric_wearhouse: datefabricwearhouse,
        comment: "Approved: " + comment,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();

    return "ok";
  };

  const next = async (status: any, product_id: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/orders_produts/next/${params.order_id}`,
      data: {
        status_id: status,
        product_id: product_id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();
    return "ok";
  };
  const notApprovedOption = async (feedback: string = "") => {
    console.log(`Article ${product?.product.name} is not approved!!`);
    var order_id = product?.data?.id;
    var product_id = product?.product?.id;
    if (!feedback) {
      await approveOptAndComment({
        order_id,
        product_id,
        // comment: `Not Approved: ${comment}`,
        status_id: 6,
      });
    } else {
      await approveOptAndComment({
        order_id,
        product_id,
        // comment: `Not Approved: ${comment}`,
        status_id: 6,
        // feedback,
      });
    }
    await rejectOrAcceptProto({
      response: "reject",
      id: +product_id,
      order_id,
      comment: `Not Approved: ${comment}`,
    });

    setIsVisible(false);
    setComment("");
    setTimeout(() => {}, 2000);
  };

  const approve = async (id: any, status_id: any, product_id: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "post",
      url: `/orders_produts/addCommentApprove/${params.order_id}`,
      data: {
        client_id: id,
        status_id: status_id,
        product_id: product_id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    /*  if (status_id !== 5) {
      const { data: reponse2 } = await axiosInstance({
        method: "put",
        url: `/orders_produts/next/${params.order_id}`,
        data: {
          status_id: status_id + 1,
          product_id: product_id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } */
    window.location.reload();
    return "ok";
  };
  const fetchOrder = () => {
    let token = localStorage.getItem("token");
    setIsLoading(true);
    return axiosInstance({
      method: "get",
      url: `/orders/${params.order_id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setIsLoading(false);
      setProduct({
        data: res.data,
        product: res.data.products.find(
          (el: any) => el.id == params.product_id
        ),
      });
    });
  };
  const { confirm } = Modal;
  const onChange = (value: any) => {
    console.log(`selected ${value}`);
    setSelectdStep(value);
    showConfirm(value);
  };

  function showConfirm(value: any) {
    confirm({
      title: "You are moving to the selected step, Proceed... ?",
      onOk() {
        approve(
          product?.product?.client?.id,
          product?.product?.status?.id,
          product?.product?.id
        );
        next(value, product?.product?.id);
      },
      onCancel() {
        console.log("Cancel");
        setSelectdStep("1");
      },
    });
  }

  const onSearch = (value: any) => {
    console.log("search:", value);
  };
  const { data } = useQuery("single_order", () => fetchOrder(), {
    keepPreviousData: true,
  });
  /* 
  console.log(product?.data);
  console.log(product?.product?.proto); */

  const stepName = ["PROTO", "PRE SMS", "SMS", "OK PROD", "PRODUCTION"];

  return isLoading ? (
    <div
      style={{ width: "100%", height: "100%" }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <div className="row myorder_confirmation" style={{ minHeight: "100vh" }}>
      <div
        className="col-12 col-md-5 p-0 d-flex align-items-center"
        style={{ background: "#fcfdff", height: "100%" }}
      >
        {/* <img
            src={
              product.product.proto
                ? process.env.REACT_APP_STORAGE_URL + product.product.proto
                : proto_illustration
            }
            alt="prototype"
            className="proto_img img-fluid"
            style={{
              objectFit:
                product.product && product.product.proto ? "contain" : "cover",
            }}
          /> */}
        {/*        <iframe
          src={
            product?.product.proto
              ? process?.env?.REACT_APP_STORAGE_URL + product?.product.proto
              : proto_illustration
          }
          style={{
            width: "100%",
            height: "calc(100vh - 227px)",
            border: "none",
          }}
        /> */}
        <iframe
          src={
            product?.product?.proto
              ? product?.product?.proto
              : product?.product?.link_360
          }
          style={{
            width: "100%",
            height: "calc(100vh - 227px)",
            border: "none",
          }}
        />
      </div>
      <div className="col-12 col-md-7 proto_container pl-3">
        <div
          className=" m-4"
          style={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="proto_header">
            <img
              src={backArrow}
              className="back_arrow_folder"
              alt="back arrow"
              onClick={() => history?.back()}
            />
            <h1>My orders</h1>
          </div>
          <div>
            {product?.product && (
              <div>
                <Tooltip
                  placement="bottom"
                  title={isOpened == false ? "Update" : "View"}
                >
                  <Button
                    type="ghost"
                    shape="circle"
                    size="large"
                    className="update_product_btn"
                    icon={
                      isOpened == false ? (
                        <EditOutlined />
                      ) : (
                        <EyeOutlined></EyeOutlined>
                      )
                    }
                    onClick={edit}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </div>

        <div className="proto_breadcrumb_container my-4">
          {product?.data && (
            <p className="proto_breadcrumb">{`${product?.data?.client?.name}/${
              product?.product?.name || ""
            }`}</p>
          )}{" "}
        </div>
        {product?.product?.orders_status.map((el: any) => {
          console.log(product?.product?.status?.id - 1);
          return (
            <>
              {el.proto_confirmation === "ACCEPTED" &&
                el.status_id == product?.product?.status?.id && (
                  <div className="col-2">
                    <Tag
                      icon={<CheckOutlined />}
                      style={{
                        borderRadius: "15px",
                        padding: "5px 9px 5px 9px",
                      }}
                      color="#00468c"
                    >
                      Approved
                    </Tag>
                  </div>
                )}
            </>
          );
        })}

        <div className="steps_progress mt-4">
          <Steps
            current={product?.product?.status?.id - 1}
            labelPlacement={"vertical"}
            className={
              product?.product === undefined
                ? "d-flex justify-content-center cancelled"
                : ""
            }
          >
            {product?.product ? (
              <>
                <Step
                  title="PROTO"
                  onClick={() => setSetp(1)}
                  style={{
                    cursor:
                      product?.product?.status?.id >= 1 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    product?.product?.status?.id >= 1 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="PRE SMS"
                  onClick={() => setSetp(2)}
                  style={{
                    cursor:
                      product?.product?.status?.id >= 2 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    product?.product?.status?.id >= 2 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="SMS"
                  onClick={() => setSetp(3)}
                  style={{
                    cursor:
                      product?.product?.status?.id >= 3 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    product?.product?.status?.id >= 3 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="OK PROD"
                  onClick={() => setSetp(4)}
                  style={{
                    cursor:
                      product?.product?.status?.id >= 4 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    product?.product?.status?.id >= 4 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="PRODUCTION"
                  onClick={() => setSetp(5)}
                  style={{
                    cursor:
                      product?.product?.status?.id >= 5 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    product?.product?.status?.id >= 5 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
              </>
            ) : (
              <>
                <Step title="CANCELLED" />
              </>
            )}
          </Steps>
        </div>
        {!product?.product && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h4
              className="text-center"
              style={{ color: "red", fontWeight: 400 }}
            >
              This product has been cancelled
            </h4>
            <div className="proto_footer_btns my-4">
              <Button
                type="default"
                className="approve_btn"
                onClick={() =>
                  routerHistory.push(`/all-clients/${params.id}/2`)
                }
              >
                Go back to orders
              </Button>
            </div>
          </div>
        )}

        {isOpened == false ? (
          <>
            {" "}
            <div className="proto_footer mt-5">
              <div className="mt-4">
                <h1 className="my-3">
                  {product?.product && product?.product?.name} {""}
                  {product?.product && product?.product?.code}
                </h1>
                {/*                 <p>{product?.product && product?.product?.description}</p>
                 */}
                {product?.product?.orders_status.map((el: any) => {
                  {
                    return (
                      <>
                        {el.status_id == step ? (
                          <>
                            <table
                              className="table_production "
                              style={{
                                marginBottom: "25px",
                                borderRadius: "1em",
                              }}
                            >
                              <tr className="border">
                                <th className="border-right p-3">Qty</th>
                                <td className="p-3" style={{ width: "150px" }}>
                                  {el.qty || "-"}
                                </td>
                              </tr>
                              <tr className="border">
                                <th className="border-right p-3">Size qty</th>
                                <td className="p-3">{el.size_qty || "-"}</td>
                              </tr>
                              {/*     <tr className="border">
                                <th className="border-right p-3">
                                  Date trims wearhouse
                                </th>
                                <td className="p-3">
                                  {el.date_trims_wearhouse
                                    ? moment(el.date_trims_wearhouse).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "-"}
                                </td>
                              </tr>
                              <tr className="border">
                                <th className="border-right p-3">
                                  Date fabric wearhouse
                                </th>
                                <td className="p-3">
                                  {el.date_fabric_wearhouse
                                    ? moment(el.date_fabric_wearhouse).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "-"}
                                </td>
                              </tr> */}
                              <tr className="border">
                                <th className="border-right p-3">
                                  Start production date
                                </th>
                                <td className="p-3">
                                  {el.start_production_date
                                    ? moment(el.start_production_date).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "-"}
                                </td>
                              </tr>
                              <tr className="border">
                                <th className="border-right p-3">
                                  Shipping date
                                </th>
                                <td className="p-3">
                                  {el.shipping_date
                                    ? moment(el.shipping_date).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "-"}
                                </td>
                              </tr>
                              <tr className="border">
                                <th className="border-right p-3">
                                  Delivery date
                                </th>
                                <td className="p-3">
                                  {el.delivery_date
                                    ? moment(el.delivery_date).format(
                                        "YYYY-MM-DD"
                                      )
                                    : "-"}
                                </td>
                              </tr>
                            </table>
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })}
              </div>{" "}
              {/*    {product?.product?.status?.id == 5 && (
                <table className="table_production bg-white">
                  <tr className="border">
                    <th className="border-right p-3">Quantity</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {product?.product.qty}
                    </td>
                  </tr>
                  <tr className="border">
                    <th className="border-right p-3">Start Production</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {product?.product.start_production_date
                        ? moment(
                            product?.product?.start_production_date
                          ).format("YYYY-MM-DD")
                        : ""}
                    </td>
                  </tr>
                  <tr className="border">
                    <th className="border-right p-3">Shipping Date</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {product?.product.shipping_date
                        ? moment(product?.product?.shipping_date).format(
                            "YYYY-MM-DD"
                          )
                        : ""}
                    </td>
                  </tr>
                </table>
              )} */}
            </div>
          </>
        ) : (
          <>
            {" "}
            <div className="proto_breadcrumb_container">
              {/*  {product?.product?.status?.id !== 5 && (
                <div>
                  <Select
                    showSearch
                    placeholder="Select Step"
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ width: 150, borderRadius: "5px" }}
                    defaultValue={product?.product?.status?.name}
                  >
                    <Option
                      value="1"
                      disabled={product?.product?.status?.id >= 1}
                    >
                      PROTO
                    </Option>
                    <Option
                      value="2"
                      disabled={product?.product?.status?.id >= 2}
                    >
                      PRE SMS
                    </Option>
                    <Option
                      value="3"
                      disabled={product?.product?.status?.id >= 3}
                    >
                      SMS
                    </Option>
                    <Option
                      value="4"
                      disabled={product?.product?.status?.id >= 4}
                    >
                      OK PROD
                    </Option>
                    <Option
                      value="5"
                      disabled={product?.product?.status?.id >= 5}
                    >
                      PRODUCTION
                    </Option>
                  </Select>{" "}
                  <Popconfirm
                    title="You are moving to the selected step, Proceed... ?"
                    onConfirm={() => next(selectdStep, product?.product?.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="default"
                      className="approve_btn"
                      style={{
                        color: "white",
                        background: "#00468c",
                        border: "none",
                        borderRadius: "5px",
                      }}
                    >
                      Go to {selectdStep}
                    </Button>
                  </Popconfirm>
                </div>
              )} */}
              <>
                <div className="proto_footer_btns my-4">
                  <Button
                    type="default"
                    className="cancel_btn"
                    style={{ height: "40px" }}
                    onClick={() => showCancelDrawer()}
                  >
                    Cancel
                  </Button>
                  {product?.product?.status?.id === 5 ? (
                    <Button
                      type="default"
                      className="approve_btn"
                      onClick={() =>
                        approve(
                          product?.data?.client?.id,
                          product?.product?.status?.id,
                          product?.product?.id
                        )
                      }
                      disabled={product?.product?.status?.comments?.length > 0}
                    >
                      Approve
                    </Button>
                  ) : (
                    <>
                      {product?.product?.status?.id !== 5 && (
                        <div style={{ marginLeft: "25px" }}>
                          <Select
                            showSearch
                            placeholder="Select Step"
                            optionFilterProp="children"
                            // onChange={onChange}
                            onSearch={onSearch}
                            onSelect={onChange}
                            filterOption={(input, option) =>
                              (option!.children as unknown as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            size={"large"}
                            style={{
                              width: 150,

                              borderRadius: "5px",
                            }}
                            defaultValue={product?.product?.status?.name}
                          >
                            <Option
                              value="1"
                              disabled={product?.product?.status?.id >= 1}
                            >
                              PROTO
                            </Option>
                            <Option
                              value="2"
                              disabled={product?.product?.status?.id >= 2}
                            >
                              PRE SMS
                            </Option>
                            <Option
                              value="3"
                              disabled={product?.product?.status?.id >= 3}
                            >
                              SMS
                            </Option>
                            <Option
                              value="4"
                              disabled={product?.product?.status?.id >= 4}
                            >
                              OK PROD
                            </Option>
                            <Option
                              value="5"
                              disabled={product?.product?.status?.id >= 5}
                            >
                              PRODUCTION
                            </Option>
                          </Select>{" "}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
              {product?.product?.orders_status.map((el: any) => {
                {
                  return (
                    <>
                      {el.status_id == product?.product?.status?.id ? (
                        <div>
                          <div>
                            <div className="mb-4">
                              {product?.product?.status?.id != 5 && (
                                <>
                                  <label className="mr-3 mb-0"> Proto</label>
                                  <Input
                                    type="text"
                                    defaultValue={el.proto}
                                    onChange={handleChangeProto}
                                    style={{
                                      borderRadius: "5px",
                                    }}
                                  ></Input>
                                </>
                              )}

                              {(product?.product?.status?.id == 5 ||
                                product?.product?.status?.id == 4 ||
                                product?.product?.status?.id == 3 ||
                                product?.product?.status?.id == 2 ||
                                product?.product?.status?.id == 1) && (
                                <>
                                  <label className="mr-3 mb-0">
                                    {" "}
                                    Quantity{" "}
                                  </label>

                                  <Input
                                    type="text"
                                    defaultValue={qty || el.qty}
                                    style={{
                                      borderRadius: "5px",
                                      marginBottom: "15px",
                                    }}
                                    onChange={(e: any) =>
                                      setQty(e.target.value)
                                    }
                                  ></Input>
                                  <label className="mr-3 mb-0">
                                    Size's Quantity{" "}
                                  </label>

                                  <Input
                                    type="text"
                                    style={{
                                      borderRadius: "5px",
                                      marginBottom: "15px",
                                    }}
                                    defaultValue={size_qty || el.size_qty}
                                    placeholder="S:10;M:10"
                                    onChange={(e: any) =>
                                      setSizeQty(e.target.value)
                                    }
                                  ></Input>
                                  <label className="mr-3 mb-0">
                                    Delivery date
                                  </label>
                                  <Input
                                    type="date"
                                    style={{
                                      borderRadius: "5px",
                                      marginBottom: "15px",
                                    }}
                                    value={
                                      deliverydate ||
                                      moment(el.delivery_date).format(
                                        "YYYY-MM-DD"
                                      )
                                    }
                                    onChange={handleChangeDeliveryDate}
                                  ></Input>
                                </>
                              )}
                              <label className="mr-3 mb-0">
                                {" "}
                                Start production date{" "}
                              </label>
                              <Input
                                type="date"
                                value={
                                  startDate ||
                                  moment(el.start_production_date).format(
                                    "YYYY-MM-DD"
                                  )
                                }
                                onChange={handleChangeStartDate}
                                style={{
                                  borderRadius: "5px",
                                  marginBottom: "15px",
                                }}
                              ></Input>
                              <label className="mr-3 mb-0">
                                {" "}
                                Shipping date{" "}
                              </label>
                              <Input
                                type="date"
                                value={
                                  shippingDate ||
                                  moment(el.shipping_date).format("YYYY-MM-DD")
                                }
                                onChange={handleChangeShippingDate}
                                style={{
                                  borderRadius: "5px",
                                  marginBottom: "15px",
                                }}
                              ></Input>

                              {/*    <label className="mr-3 mb-0">
                                {" "}
                                Date fabric wearhouse{" "}
                              </label>
                              <Input
                                type="date"
                                value={
                                  datefabricwearhouse ||
                                  moment(el.date_fabric_wearhouse).format(
                                    "YYYY-MM-DD"
                                  )
                                }
                                onChange={handleChangeDateFabricwearhouse}
                                style={{
                                  borderRadius: "5px",
                                  marginBottom: "15px",
                                }}
                              ></Input>
 */}
                              {/*    <label className="mr-3 mb-0">
                                {" "}
                                Date trims wearhouse{" "}
                              </label>
                              <Input
                                type="date"
                                value={
                                  datetirmswearhouse ||
                                  moment(el.date_trims_wearhouse).format(
                                    "YYYY-MM-DD"
                                  )
                                }
                                onChange={handleChangeDateTirmswearhouse}
                                style={{
                                  borderRadius: "5px",
                                  marginBottom: "15px",
                                }}
                              ></Input> */}
                            </div>
                            <div>
                              <textarea
                                rows={4}
                                name="comment"
                                placeholder="Add client comment"
                                className="comment_proto_order my-4"
                                onChange={(e: any) =>
                                  setComment(e.target.value)
                                }
                                disabled={
                                  product?.product?.status?.comments?.length > 0
                                }
                              ></textarea>
                            </div>

                            <div className="proto_footer_btns my-4">
                              <Button
                                type="default"
                                className="cancel_btn"
                                onClick={() =>
                                  valider(
                                    product?.product?.status?.id,
                                    product?.product?.id
                                  )
                                }
                              >
                                Save
                              </Button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                }
              })}
            </div>
          </>
        )}
        {isOpened == false && (
          <div className="proto_footer">
            {product?.product && product?.product?.allComment.length > 0 ? (
              <List
                itemLayout="horizontal"
                dataSource={product?.product?.allComment}
                renderItem={(item: any) => (
                  <>
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            src={
                              item.client?.logo
                                ? process?.env?.REACT_APP_STORAGE_URL +
                                  item?.client?.logo
                                : avatar_placeholder
                            }
                          />
                        }
                        title={
                          <a>
                            <span>{stepName[item?.status_id - 1]}</span>
                            {item.comment?.includes("NOT")
                              ? " NOT APPROVED BY"
                              : " APPROVED BY"}{" "}
                            {product?.data?.client?.name}
                          </a>
                        }
                        description={item.comment}
                      />
                    </List.Item>
                  </>
                )}
              />
            ) : (
              <h4 className="text-muted text-center my-5">No comments</h4>
            )}
          </div>
        )}

        <CancelOrderDrawer
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          article={product}
          notApprovedOption={notApprovedOption}
          orderType={"demco_order"}
          productToCancel={product?.product?.id}
          approvingAndCommentLoading={approvingAndCommentLoading}
          rejectOrAcceptProtoLoading={rejectOrAcceptProtoLoading}
        />
      </div>
    </div>
  );
};

export default NormalOrderProgress;
